module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-button', {
    attrs: {
      "variant": _vm.variant
    },
    on: {
      "click": function($event) {
        return _vm.action()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.text))]), _c('svg-icon', {
    attrs: {
      "name": _vm.icon
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a71aee0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MyButton.vue
// module id = 833
// module chunks = 0